/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TaskUpdateBodyDoc } from './taskUpdateBodyDoc';
import type { TaskUpdateCallOutcome } from './taskUpdateCallOutcome';
import type { TaskUpdateMessageDoc } from './taskUpdateMessageDoc';
import type { TaskUpdatePriority } from './taskUpdatePriority';
import type { TaskUpdateStatus } from './taskUpdateStatus';
import type { TaskUpdateTaskNoteDoc } from './taskUpdateTaskNoteDoc';
import type { TaskUpdateTextOutcome } from './taskUpdateTextOutcome';
import type { TaskUpdateThreadMode } from './taskUpdateThreadMode';

/**
 * Partial update. Every field optional; at least one must be set.
 *
 * The service layer enforces:
 * - ``assignee_user_id`` change → 422 for sequence-origin tasks.
 * - per-field type compatibility (e.g. ``subject`` only valid on email
 *   types). We keep this layer wide so a single PATCH route serves
 *   every type without per-type variants.
 */
export interface TaskUpdate {
  title?: string | null;
  assignee_user_id?: string | null;
  due_at?: string | null;
  priority?: TaskUpdatePriority;
  status?: TaskUpdateStatus;
  mailbox_id?: string | null;
  to_email?: string | null;
  subject?: string | null;
  body_doc?: TaskUpdateBodyDoc;
  thread_mode?: TaskUpdateThreadMode;
  cc?: string[] | null;
  bcc?: string[] | null;
  include_sender_signature?: boolean | null;
  include_unsubscribe_link?: boolean | null;
  linkedin_account_id?: string | null;
  target_linkedin_url?: string | null;
  invitation_note?: string | null;
  message_doc?: TaskUpdateMessageDoc;
  include_signature?: boolean | null;
  task_note_doc?: TaskUpdateTaskNoteDoc;
  phone_number_used?: string | null;
  call_outcome?: TaskUpdateCallOutcome;
  text_outcome?: TaskUpdateTextOutcome;
}
